import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import {
  IGKRapport,
  IGKTestAvSkapreguleringensResponstidResultater,
} from "@mcapps/shared/reportSchemas/gkReportSchema";
import { Paper, Stack, Title } from "@mantine/core";
const TestAvSkapreguleringsResponstid: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKTestAvSkapreguleringensResponstidResultater;
}> = ({ data, onUpdateEditData }) => {
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Test av skapreguleringens responstid</Title>
        <div className="d-flex flex-column mt-4">
          <McInputNew
            label="Målt trykkfall før test (Pa):"
            value={data.inndata.trykkfallFoerTest}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData(
                "testResultater.testAvSkapreguleringensResponstid.inndata.trykkfallFoerTest",
                Number(e.target.value),
              )
            }
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-4">
          <McInputNew
            label="Målt trykk etter test (Pa):"
            value={data.inndata.trykkfallEtterTest}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData(
                "testResultater.testAvSkapreguleringensResponstid.inndata.trykkfallEtterTest",
                Number(e.target.value),
              )
            }
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-4">
          <McInputNew
            label="Målt tid før trykkfall har returnert (s):"
            value={data.inndata.tidFoerTrykkfallHarRetunert}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData(
                "testResultater.testAvSkapreguleringensResponstid.inndata.tidFoerTrykkfallHarRetunert",
                Number(e.target.value),
              )
            }
            className="w-25"
          />
        </div>
        <div className="w-50 mt-4">
          <McTextAreaNew
            label="Kommentar:"
            value={data.inndata.kommentar}
            onChange={(e) =>
              onUpdateEditData("testResultater.testAvSkapreguleringensResponstid.inndata.kommentar", e.target.value)
            }
          />
        </div>
      </Stack>
    </Paper>
  );
};
export default TestAvSkapreguleringsResponstid;